import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Online portal login. The portal is under maintenance, so the form takes a
// mobile number but only explains that; nothing is sent anywhere.
function Login() {
    const [mobile, setMobile] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        setSubmitted(true);
    };

    return (
        <div className="dd-login">
            <div className="dd-login-card">
                <Link to="/" className="dd-login-logo">
                    <span className="dd-logo-red" role="img" aria-label="Drive.Day" />
                </Link>
                <h1 className="dd-login-title">Log in</h1>
                <p className="dd-login-sub">
                    Log in to the Drive.Day online portal with your mobile number.
                </p>
                <div className="dd-login-notice" role="status">
                    <i className="fa-jelly-fill fa-regular fa-wrench" />
                    <p>
                        <strong>The online portal is currently under maintenance.</strong> You can
                        still log in and use everything in the Drive.Day app.
                    </p>
                </div>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="dd-login-mobile">Mobile number</label>
                    <input
                        id="dd-login-mobile"
                        type="tel"
                        inputMode="tel"
                        autoComplete="tel"
                        placeholder="07700 900000"
                        value={mobile}
                        onChange={(e) => {
                            setMobile(e.target.value);
                            setSubmitted(false);
                        }}
                        required
                    />
                    <button type="submit" className="main-btn">
                        Send code
                    </button>
                </form>
                {submitted && (
                    <p className="dd-login-error" role="alert">
                        Sorry, you can&apos;t log in here while the online portal is under
                        maintenance. Please log in with the Drive.Day app.
                    </p>
                )}
                <Link to="/" className="dd-login-back">
                    <i className="fa-jelly-fill fa-regular fa-arrow-left" /> Back to drive.day
                </Link>
            </div>
        </div>
    );
}

export default Login;
